module.exports = __webpack_public_path__ + "img/v1.4a0460e0.jpg";